import type {
    ActivationAlertsContractSocialAdPlatform,
    ActivationAlertsContractSocialMediaChannel,
} from "@similarweb/pro-api-client";

import { AssetsService } from "app/services/AssetsService";

type ChannelIconName =
    | "audiencenetwork"
    | "facebook"
    | "google"
    | "instagram"
    | "linkedin"
    | "messenger"
    | "meta"
    | "threads"
    | "tiktok"
    | "whatsapp"
    | "youtube";

type ImageProps = { iconName: ChannelIconName; size?: number };

const Image = ({ iconName, size = 16 }: ImageProps) => (
    <img
        src={AssetsService.assetUrl(`/images/activation-alerts/channel-tag/${iconName}.png`)}
        alt={iconName}
        width={size}
        height={size}
    />
);

type Channel = ActivationAlertsContractSocialAdPlatform | ActivationAlertsContractSocialMediaChannel | "Google";

export type ChannelIconProps = { channel: Channel } & Pick<ImageProps, "size">;

export const ChannelIcon = ({ channel, size }: ChannelIconProps) => {
    const iconName = channel.toLowerCase() as Lowercase<Channel>;

    return (
        <Image
            iconName={iconName}
            size={size}
        />
    );
};
